import {
  FlowOcrBoundingBoxMode,
  FlowOcrDetailLevel,
  type FlowOcrV2Block,
  FlowOcrV2BlockConfigSchema,
} from 'flow-schema';

import { api } from 'common';

import { OcrV2BlockFormFields } from './FormFields.tsx';
import { OcrV2BlockDocumentationMarkdown } from './documentation.ts';
import type { BlockConfigProps } from '../../../types.ts';

export const ocrV2Config: BlockConfigProps<FlowOcrV2Block['config']> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'extractText',
  defaultConfig: {
    detailLevel: FlowOcrDetailLevel.None,
    boundingBoxMode: FlowOcrBoundingBoxMode.None,
    fileReference: '',
    method: api.FlowDefinition.RECOMMENDED_OCR_METHOD,
  },
  configFields: {
    schema: FlowOcrV2BlockConfigSchema,
    FormFields: OcrV2BlockFormFields,
  },
  documentationMarkdown: OcrV2BlockDocumentationMarkdown,
};
